import { ApiError } from '../shared/api/HttpClient';
import { localizedProblem } from '../shared/i18n';

export function authProblem(reason: unknown): string {
  if (!(reason instanceof ApiError)) return reason instanceof Error ? reason.message : 'Сервер не відповів. Спробуйте ще раз.';
  if (reason.problem.status === 401 && reason.problem.code === 'invalid_credentials') return 'Електронна пошта або пароль неправильні.';
  if (reason.problem.status === 401 && reason.problem.code === 'invalid_second_factor') return 'Код неправильний або вже прострочений.';
  if (reason.problem.status === 429) return 'Забагато спроб входу. Зачекайте й повторіть.';
  if (reason.problem.status === 403) return 'Дію заблоковано перевіркою безпеки. Оновіть сторінку.';
  return localizedProblem(reason.problem);
}

export function initials(displayName: string, email: string): string {
  const words = displayName.trim().split(/\s+/).filter(Boolean);
  const letters = words.slice(0, 2).map((word) => word[0]?.toUpperCase() ?? '').join('');
  return letters || email[0]?.toUpperCase() || 'U';
}

export function destinationLabel(path: string): string {
  if (path.startsWith('/studio')) return 'ефірна студія';
  if (path.startsWith('/dj')) return 'мобільний пульт ведучого';
  if (path.startsWith('/admin/monitoring')) return 'моніторинг';
  if (path.startsWith('/admin/library')) return 'медіатека';
  if (path.startsWith('/admin/segue')) return 'редактор переходів';
  if (path.startsWith('/account')) return 'безпека акаунта';
  return 'панель керування';
}
